import React, { FC } from 'react';

import './FoodItem.scss';

interface Props {
  foodItem: string;
}

const FoodItem: FC<Props> = props => {
  const { foodItem } = props;
  return (
    <div className='food-item'>
      <p className='food-text'>{foodItem}</p>
    </div>
  );
};

export default FoodItem;
